import { render, staticRenderFns } from "./CardTarjaTropaGEV2.vue?vue&type=template&id=b3e99ef8&scoped=true"
import script from "./CardTarjaTropaGEV2.vue?vue&type=script&lang=js"
export * from "./CardTarjaTropaGEV2.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaTropaGEV2.vue?vue&type=style&index=0&id=b3e99ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e99ef8",
  null
  
)

export default component.exports